module.exports = __webpack_public_path__ + "img/img (56).eca542cd.jpg";